import api from 'apis/config/api-service';

interface User {
  id: string | number;
  [key: string]: any;
}

const cmsAppUsers = 'api/v1/cms/app-users';

export default {
  // App users are only edited from the CMS (the backend accepts name, email, phoneNumber, isActive, hasVerifiedEmail).
  addOrUpdateUser: (user: User) => api.patch(`${cmsAppUsers}/${user.id}`, user),
  getUserById: (userId: string | number) => api.get(`${cmsAppUsers}/${userId}`),
};
